import type { CopyShape } from "@tami/core/intl";

import type { PERFORMANCE_SCRIPT_COPY_PT_BR } from "../performance-script.copy";

export const PERFORMANCE_SCRIPT_COPY_EN_US: CopyShape<typeof PERFORMANCE_SCRIPT_COPY_PT_BR> = {
  perfIntro: {
    narrative: "Creator performance: track followers, engagement and how your socials are growing, all in one place.",
  },
  perfMonth: {
    narrative: "Go month by month to compare results and spot trends over time.",
    callout: "Month picker — compare this month's performance with previous periods.",
  },
  perfSocial: {
    narrative: "Instagram, TikTok and your other connected networks — followers and engagement rate side by side.",
    callout: "Each network with its handle, follower count and up-to-date engagement.",
  },
  perfOverview: {
    narrative: "Combined totals show the size of your audience and your average engagement.",
  },
  perfAggregated: {
    narrative: "Total followers, number of posts and average engagement — KPIs that steer your content strategy.",
    callout: "Aggregated metrics from all your connected networks for the period.",
  },
  perfCharts: {
    narrative: "Follower and engagement curves reveal spikes, dips and the impact of campaigns or viral posts.",
    callout: "Line charts by network — filter Instagram, TikTok and others in the legend.",
  },
};
